"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*export const constants = {
    LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_TOYOTA: /^https:\/\/(test|stage)\.account\.toyota\.com\/api\/oauth2\/realms\/root\/realms\/toyota\/authorize|^https:\/\/account\.toyota\.com\/api\/oauth2\/realms\/root\/realms\/toyota\/authorize/,
    LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_LEXUS: /^https:\/\/(test|stage)\.account\.lexus\.com\/api\/oauth2\/realms\/root\/realms\/lexus\/authorize|^https:\/\/account\.lexus\.com\/api\/oauth2\/realms\/root\/realms\/lexus\/authorize/,
    LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_SAML: /^(https:|http:)\/\/(login)\.(qa-tmna|stg-tmna|tmna)\.toyotadriverslogin\.com/,
}
*/
exports.brandRegexMap = {
    T: /^https:\/\/(test|stage)*\.*account\.toyota\.com\/api\/oauth2\/realms\/root\/realms\/toyota\/authorize/,
    L: /^https:\/\/(test|stage)*\.*account\.lexus\.com\/api\/oauth2\/realms\/root\/realms\/lexus\/authorize/,
    S: /^(https:|http:)\/\/(login)\.(qa-tmna|stg-tmna|tmna)\.toyotadriverslogin\.com/
};
exports.validHostnames = ['account.toyota.com', 'test.account.toyota.com', 'stage.account.toyota.com', 'account.lexus.com', 'test.account.lexus.com', 'stage.account.lexus.com', 'login.qa-tmna.toyotadrivesrlogin.com', 'login.stg-tmna.toyotadriverslogin.com', 'login.tmna.toyotadriverslogin.com'];
exports.logoutURLRegexToyota = [
    "^https:\/\/api\.(dev|test|stage|demo)*\.*dg\.toyota\.com",
    "(toyota|toyotaowners|toyotafinancial|toyotapco3)\.com"
];
exports.logoutURLRegexLexus = [
    "^https:\/\/api\.(dev|test|stage|demo)*\.*dg\.toyota\.com",
    "(lexus|lexusfinancial)\.com"
];
//export const goToURLRegexToyota = new RegExp(constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_TOYOTA);
//export const goToURLRegexLexus = new RegExp(constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_LEXUS);
//export const goToURLRegexSAML = new RegExp(constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_SAML);
